import React from 'react'
import logo from "../../images/logo.png"

const Header = ({ resources, title }) => {
    return (
        <>
            <div className="container-fluid px-0">
                <div>
                    <img src={logo} alt="Logo" className="img-fluid header-logo" />
                </div>
            </div>

            <div className="header-title-box">
                <div className="text-center">
                    <span>{title}</span>
                </div>
            </div>
        </>
    )
}

export default Header